import { useState, useEffect } from 'react'
import './Form.css'
import './Home.css'
import '../global'
import TodoItem from '../components/TodoItem'
import ItemPopup from '../components/ItemPopup'

const SAVING = 'Saving...'
const SAVE_ERROR = 'Error Saving.'
const SAVED = 'Saved!'

String.prototype.replaceAt = function(index, replacement) {
    return this.substring(0, index) + replacement + this.substring(index + replacement.length);
}

Number.prototype.setLeadingZeros = function(n) {
    let res = this + ""
    while (res.length < n) {
        res = '0' + res
    }
    return res
}

Array.prototype.fixDueDates = function() {
    this.map(obj => {
        if (obj.dateDue == null) return;
        const due = new Date(obj.dateDue)
        const dateFormatted = due.getFullYear() + '-'
                              + (due.getMonth() + 1).setLeadingZeros(2) + '-'
                              + due.getDate().setLeadingZeros(2) + "T"
                              + due.getHours().setLeadingZeros(2) + ":"
                              + due.getMinutes().setLeadingZeros(2)
        obj.dateDue = dateFormatted
        return obj
    })
}

function Home() {

    const [status, setStatus] = useState('')
    const [todoItems, setTodoItems] = useState([])
    const [name] = useState(localStorage.getItem('name'))
    const [createActive, setCreateActive] = useState(false)
    const [editActive, setEditActive] = useState(false)
    const [editData, setEditData] = useState({})
    const [tagFilter, setTagFilter] = useState(-1)
    const [sortType, setSortType] = useState(0)

    useEffect(() => {
        const getItems = async () => {
            const url = global.API_BASE + '/item/fetch-all/' + localStorage.getItem('token')
            const data = await fetch(url).then(res => res.json())
            data.fixDueDates()
            setTodoItems(data)
        }

        getItems()


    }, [])


    const signOutClicked = () => {
        localStorage.removeItem('token')
        window.location.reload()
    }

    const toggleItem = async id => {
        setStatus(SAVING)
        let completed = false
        const newTodoItems = todoItems.map(obj => {
            if (obj._id === id) {
                completed = !obj.completed
                return { ...obj, completed: completed }
            }
            return obj
        })
        setTodoItems(newTodoItems)

        const result = await fetch(global.API_BASE + '/item/set-completed', {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                _id: id,
                completed: completed
            })
        }).catch(() => setStatus(SAVE_ERROR))

        if (!result) return
        setStatus(SAVED)
    }

    const toggleCreate = () => {
        setEditActive(false)
        setCreateActive(!createActive)
        document.body.style.overflow = createActive ? "visible" : "hidden"
    }

    const toggleEdit = data => {
        setEditData(data)
        setCreateActive(false)
        setEditActive(!editActive)
        document.body.style.overflow = editActive ? "visible" : "hidden"
    }

    const checkInvalidInput = data => {

        if (data.label === '') return "Please add a label"
        if (data.dateDue === '') return "Please add a date or uncheck the box"
        if (data.tag === '') return "Please add a tag or uncheck the box"
        return null

    }

    const createItem = async data => {
        const error = checkInvalidInput(data)
        if (error != null) return error

        data = { ...data, token: localStorage.getItem('token') }
        const result = await fetch(global.API_BASE + '/item/new', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .catch(() => { return false })

        if (!result) return "Something went wrong"
        toggleCreate()
        const newTodoItems = [...todoItems, result]
        newTodoItems.fixDueDates()
        setTodoItems(newTodoItems)
    }

    const updateItem = async data => {
        const error = checkInvalidInput(data)
        if (error != null) return error
        const result = await fetch(global.API_BASE + '/item/update', {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .catch(() => { return false })

        if (!result) return "Something went wrong"

        toggleEdit()

        const newTodoItems = todoItems.map(obj => {
            if (obj._id === data._id) {
                obj = data
            }
            return obj
        })

        newTodoItems.fixDueDates()

        setTodoItems(newTodoItems)
    }

    const deleteItem = async data => {
        const id = data._id
        setStatus(SAVING)

        setTodoItems(todoItems.filter(obj => obj._id != id))

        const result = await fetch(global.API_BASE + '/item/delete/' + id, { method: "DELETE" })
            .catch(() => setStatus(SAVE_ERROR))
        setStatus(SAVED)

        setCreateActive(false)
        setEditActive(false)
    }

    const getUniqueTags = () => {
        const tagSet = new Set()

        todoItems.forEach(item => {
            if (item.tag != null) {
                tagSet.add(item.tag)
            }
        })

        return [...tagSet]
    }

    const updateTagFilter = e => {
        const tagIndex = Number(e.target.value)
        setTagFilter(tagIndex)
    }

    return (
        <div>
            <div className='row'>
                <h1>Welcome, {name}!</h1>
                <label className='status-label'>{status}</label>
            </div>
            <ul className='filters'>
                <li>
                    <label>Sort By:</label>
                    <select className='dropdown sm' onChange={e => setSortType(Number(e.target.value))}>
                        <option value='0'>Date Created (Old to New)</option>
                        <option value='1'>Date Created (New to Old)</option>
                        <option value='2'>Due Date (Closest First)</option>
                        <option value='3'>Due Date (Furthest First)</option>
                    </select>
                </li>
                <li>
                    <label>Filter Tag:</label>
                    <select className='dropdown sm' onChange={updateTagFilter}>
                        <option value='-1'>All</option>
                        {getUniqueTags().map((tag, index) => <option value={index} key={index}>{tag}</option>)}
                    </select>
                </li>
            </ul>
            <label className='sm-label'>Remaining Tasks:</label>
            <hr />
            <div id='remaining-container' className='task-container'>
                {todoItems
                    .filter(obj => (!obj.completed && (tagFilter === -1 || obj.tag === getUniqueTags()[tagFilter])))
                    .sort((a, b) => {
                        if (sortType === 0)
                            return new Date(a.dateCreated) - new Date(b.dateCreated)
                        if (sortType === 1)
                            return new Date(b.dateCreated) - new Date(a.dateCreated)
                        if (sortType === 2)
                            return new Date(a.dateDue || a.dateCreated.replaceAt(0, '9')) - new Date(b.dateDue || b.dateCreated.replaceAt(0, '9'))
                        if (sortType === 3)
                            return new Date(b.dateDue || b.dateCreated.replaceAt(0, '1')) - new Date(a.dateDue || a.dateCreated.replaceAt(0, '1'))
                        return 0
                    })
                    .map(obj => <TodoItem key={obj._id} data={obj} toggle={toggleItem} editBtn={toggleEdit} deleteBtn={deleteItem} />)
                }
            </div>
            <label className='sm-label'>Completed Tasks:</label>
            <hr />
            <div id='completed-container' className='task-container'>
                {todoItems
                    .filter(obj => (obj.completed && (tagFilter === -1 || obj.tag === getUniqueTags()[tagFilter])))
                    .sort((a, b) => {
                        if (sortType === 0)
                            return new Date(a.dateCreated) - new Date(b.dateCreated)
                        if (sortType === 1)
                            return new Date(b.dateCreated) - new Date(a.dateCreated)
                        if (sortType === 2)
                            return new Date(a.dateDue || a.dateCreated.replaceAt(0, '9')) - new Date(b.dateDue || b.dateCreated.replaceAt(0, '9'))
                        if (sortType === 3)
                            return new Date(b.dateDue || b.dateCreated.replaceAt(0, '1')) - new Date(a.dateDue || a.dateCreated.replaceAt(0, '1'))
                        return 0
                    })
                    .map(obj => <TodoItem key={obj._id} data={obj} toggle={toggleItem} editBtn={toggleEdit} deleteBtn={deleteItem} />)
                }
            </div>
            {createActive ? <ItemPopup togglePopup={toggleCreate} onSubmit={createItem} tags={getUniqueTags()} /> : ''}
            {editActive ? <ItemPopup togglePopup={toggleEdit} onSubmit={updateItem} data={editData} onDelete={deleteItem} tags={getUniqueTags()} /> : ''}
            <nav>
                <label className='btn' onClick={signOutClicked}>Sign out</label>
                <label className='btn' onClick={toggleCreate}>New Task</label>
            </nav>
        </div>
    )
}

export default Home